<div class="notification-popup">
  {{data.message}}
  <span class="ico-close" (click)="sbRef.dismiss()">
  </span>
</div>
